<template>
  <figure class="post__img">
    <img
      loading="lazy"
      :src="src"
      :alt="alt"
    />
    <figcaption v-if="caption && caption.length > 0">
      <ArticleContentRenderer
        :content="caption"
        :preloaded-data="preloadedData"
      />
    </figcaption>
  </figure>
</template>

<script lang="ts" setup>
  import ArticleContentRenderer from './ArticleContentRenderer.vue';
  import type { PreloadedData } from './lib/articleComponents';
  import type { ArticleContent } from './models/ArticleContent';

  export interface Props {
    src: string;
    alt: string;
    caption: ArticleContent;
    preloadedData: PreloadedData;
  }

  defineProps<Props>();
</script>

<style lang="scss" scoped>
  @import '@/app/styles/adaptivity';

  .post__img {
    max-width: var(--width-content);
    margin: var(--alias-space-32, 32px) 0;

    img {
      display: block;
      max-width: 100%;
      max-height: 600px;
      border-radius: 2px;
    }

    figcaption {
      margin: 12px 0 0;
      font-size: 14px;
      line-height: 20px;

      :deep(a) {
        color: var(--alias-color-link-default);
        text-decoration: none;

        &:hover {
          color: var(--alias-color-text-accent-magenta);
        }
      }

      & > * {
        @include base-300-300-regular;
        margin: 0;
        padding: 0;
      }
    }

    @include mobile {
      margin: var(--alias-space-24, 24px) 0;

      figcaption {
        margin: 8px 0 0;
      }
    }
  }
</style>
